import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { Text } from 'office-ui-fabric-react/lib/Text';
import { Label } from 'office-ui-fabric-react';
import { Field, Form, Formik } from 'formik';
import PageTitle from '../../components/PageTitle';
import Main from '../../components/Main';
import styles from './SearchRoles.style.v2';
import useAPI from '../../hooks/useAPI';
import { fetchAllRoles } from '../../actions/roles';
import MultiPickerFormik from '../../components/MultiPicker/MultiPickerFormik';
import RolePermissionGrid from '../../components/RolePermissionGrid';
import Module from '../../components/Module';
import ModuleContentList from '../../components/ModuleContentList';

const SearcRoles = () => {
  const { isLoading, error } = useAPI(() => fetchAllRoles());
  const roles = useSelector(state => get(state, `entities.roles`, null));

  const errorDetail = useMemo(() => {
    if (!error) {
      return null;
    }
    let title = 'Whoops!';
    let message = 'Something went wrong. Please refresh the page to try again.';
    if (error.status === 404) {
      message = 'This role does not exist. Please try a different link.';
      title = 'Not Found';
    }
    return {
      title,
      message,
    };
  }, [error]);

  if (isLoading) {
    return (
      <Spinner
        size={SpinnerSize.medium}
        className={styles.loadingSpinner}
        data-testid="roleSpinner"
      />
    );
  }

  if (errorDetail) {
    return (
      <>
        <PageTitle>{errorDetail.title}</PageTitle>
        <Main>
          <Text>{errorDetail.message}</Text>
        </Main>
      </>
    );
  }
  let roleOptions = null;
  if (roles) {
    roleOptions = Object.values(roles)
      .filter(role => role.permissions && Object.values(role.permissions).length > 0)
      .map(role => ({
        key: role.slug,
        text: role.name,
      }));
  }

  return (
    roleOptions && (
      <>
        <Label>Select Role(s) to view the granted permissions</Label>
        <Formik initialValues={{}} validateOnChange={false} validateOnBlur={false}>
          {({ values }) => {
            let selectedRoles = [];
            if (values.roles) {
              selectedRoles = values.roles.map(selectedRole => {
                return roles[selectedRole.key];
              });
            }
            return (
              <Form>
                <Field
                  name="roles"
                  component={MultiPickerFormik}
                  options={roleOptions}
                  data-testid="role-selector"
                  aria-label="role-selector"
                  multiTag
                />

                {selectedRoles?.length > 0 && (
                  <Module className={styles.rolePermissionGrid}>
                    <ModuleContentList>
                      <RolePermissionGrid roles={selectedRoles} />
                    </ModuleContentList>
                  </Module>
                )}
              </Form>
            );
          }}
        </Formik>
      </>
    )
  );
};

export default SearcRoles;
